"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _excluded = ["classes"];
var styles = function styles(theme) {
  return {
    root: {
      margin: 0
    },
    multiline: {
      margin: 0 // Reset MUI margin
    },
    // Note that these styles propagate out to components that use List, e.g. Dropdown
    primary: {
      // Primary typography components
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: theme.typography.body2.lineHeight
    },
    secondary: {
      // Secondary typography components
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.caption.fontSize,
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: theme.typography.caption.lineHeight
    },
    dense: {},
    inset: {}
  };
};

/**
 * A component that applies correct text styling to ListItems.
 */
var ListItemText = function ListItemText(props) {
  var classes = props.classes,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = (0, _extends2.default)({
    root: classes.root,
    primary: classes.primary,
    secondary: classes.secondary
  }, classes);
  return /*#__PURE__*/_react.default.createElement(_ListItemText.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides
  }));
};
ListItemText.muiName = 'ListItemText';
ListItemText.propTypes = {
  /**
   * Alias for the `primary` property.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: _propTypes.default.bool,
  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes.default.bool,
  /**
   * The main content element.
   */
  primary: _propTypes.default.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: _propTypes.default.object,
  /**
   * The secondary content element.
   */
  secondary: _propTypes.default.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: _propTypes.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
ListItemText.defaultProps = {
  disableTypography: false,
  inset: false
};
var _default = exports.default = (0, _styles.default)(styles)(ListItemText);